var fvChannel = require('glRadio').channel('FV'),
    SidePane = require('./sidePane');


module.exports = SidePane.extend({

    initialize: function(attrs, options) {

        this.lChannel = options.lChannel;
        SidePane.prototype.initialize.apply(this, arguments);

    },

    defaults:  _.extend( {}, SidePane.prototype.defaults, {

        side: 'right',
        subPanes: ['notes', 'fullText'],
        defaultSubPane: 'notes' // TODO: from global settings

    }),

    widthStorageKey: function() {

        return fvChannel.request('localStorage').RIGHT_PANE_WIDTH;

    },

    // TODO: MEDIATE -- preclose event (should be via controller or in view or call prior)
    close: function() {

        if (this.lChannel.request('activeNote'))
            return;

        this.doClose();

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/panelCommon/models/rightPane.js
 ** module id = 757
 ** module chunks = 0
 **/